/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LoadStopAdditionalType = {
    Pickup: 'PICKUP',
    Delivery: 'DELIVERY',
    PickupDelivery: 'PICKUP_DELIVERY'
} as const;
export type LoadStopAdditionalType = typeof LoadStopAdditionalType[keyof typeof LoadStopAdditionalType];

